module.exports = {
  entry: './src/apps/rai-assessment/index.tsx',
  shortcode: 'rai-assessment',
  title: 'RAI Assessment',
  status: 'stable',
  description:
    'RAI (Responsible AI Maturity Assessment) widget which does an assessment to help companies visualize their areas of strength regarding Responsible AI.',
  preview: {
    url: `${process.env.PUBLIC_URL}/storybook/iframe.html?id=widgets-rai-assessment-components--default&viewMode=story`,
  },
  useExternalPeerDependencies: ['react', 'react-dom', 'react-intl'],
  additionalCustomProperties: {
    webSegmentPaths: ['/products'],
    availableTranslations: ['en'],
  },
};
